import React from "react";
import { AccountTypes, OwnerType, yesNoOptions } from "../../../../Common/Constant";
import { SelectInput, StyledRadioInput } from "../../../../Helpers/Inputs";
import { insurancePolicyTypeOption, insurancePolicyTypes } from "../../../ABLTC/SubComponents/SelectOptions";
import { policyOwnerships } from "../Helpers/Constants";
import { Form } from "react-bootstrap";

export default function PolicyAndInsuredFields(props) {
    const { formState, register, errors, isMSEnableSurvivorshipWorkflow, clientData, jointOwner, handleValueChange, getFirstInsuredOptions, getSecondInsuredOptions, getInsuredList } = props;
    const clientAccountType = clientData.accountType && clientData.accountType.toLowerCase()
    const isJointAccount = [AccountTypes.JOINT].includes(clientAccountType);
    const listOfAccoutToShowPolicyType = [
        AccountTypes.INDIVIDUAL,
        AccountTypes.PARTNERSHIP,
        AccountTypes.UNINCORPORATED,
        AccountTypes.LIMITED_LIABILITY,
        AccountTypes.RPM,
        AccountTypes.TRUST
    ].map(type => type.toLowerCase());

    const listOfAccoutToShowInsuredOptions = [
        AccountTypes.INDIVIDUAL,
        AccountTypes.RPM,
        AccountTypes.JOINT
    ].map(type => type.toLowerCase());

    const isShowPolicyTypeForAccountType = listOfAccoutToShowPolicyType.includes(clientAccountType);
    const isShowInsuredOptionsForAccountType = listOfAccoutToShowInsuredOptions.includes(clientAccountType);

    return (
        <React.Fragment>
            {isMSEnableSurvivorshipWorkflow && clientData.accountType &&
                (isShowPolicyTypeForAccountType || (isJointAccount && formState.policyOwnership)) &&
                <React.Fragment>
                    <Form.Group>
                        <SelectInput
                            name="insurancePolicyType"
                            id="insurancePolicyType"
                            value={formState.insurancePolicyType}
                            onChange={(e) => handleValueChange("insurancePolicyType", e.target.value)}
                            label='Is this an individual or survivorship life insurance policy?'
                            selectOptions={insurancePolicyTypeOption()}
                            errors={errors.insurancePolicyType}
                            inputRef={register}
                            disabled={props.disableSurvivorshipDropDown}
                        />
                    </Form.Group>
                    {isShowInsuredOptionsForAccountType &&
                        formState.insurancePolicyType && (formState.insurancePolicyType === insurancePolicyTypes.SURVIVORSHIP) &&
                        <React.Fragment>
                            <Form.Group>
                                <SelectInput
                                    name="insured"
                                    id="insured"
                                    value={formState.insured}
                                    onChange={(e) => handleValueChange('insured', e.target.value)}
                                    label="Who is the first insured of this survivorship policy?"
                                    isShrinkLabel
                                    selectOptions={getFirstInsuredOptions(true)}
                                    errors={errors.insured}
                                    inputRef={register}
                                />
                            </Form.Group>
                            {formState.insured &&
                                <Form.Group>
                                    <SelectInput
                                        name="secondInsured"
                                        id="secondInsured"
                                        value={formState.secondInsured}
                                        onChange={(e) => handleValueChange('secondInsured', e.target.value)}
                                        label="Who is the second insured of this survivorship policy?"
                                        isShrinkLabel
                                        selectOptions={getSecondInsuredOptions()}
                                        errors={errors.secondInsured}
                                        inputRef={register}
                                    />
                                </Form.Group>
                            }
                        </React.Fragment>
                    }
                </React.Fragment>
            }
            {
                (clientData.accountType &&
                    ((clientData.accountType.toLowerCase() === AccountTypes.INDIVIDUAL) ||
                        (isJointAccount)) ||
                    (clientAccountType === AccountTypes.UNINCORPORATED && clientData.accountSubclass.toLowerCase() === AccountTypes.SOLE_PROPRIETOR && formState.selectedOwner && formState.selectedOwner.ownerType === null) ||
                    (clientAccountType === AccountTypes.UNINCORPORATED && (formState.selectedOwner && formState.selectedOwner.ownerType && formState.selectedOwner.ownerType.toLowerCase() !== OwnerType.ORGANIZATION)) ||
                    (clientAccountType === AccountTypes.PARTNERSHIP && (formState.selectedOwner && formState.selectedOwner.ownerType && formState.selectedOwner.ownerType.toLowerCase() !== OwnerType.ORGANIZATION))
                ) && (isMSEnableSurvivorshipWorkflow ? formState.insurancePolicyType === insurancePolicyTypes.INDIVIDUAL : true) &&
                <Form.Group>
                    <StyledRadioInput
                        name="isProposedInsured"
                        id="isProposedInsured"
                        label="Is the insured the same as the client account owner?"
                        value={formState.isProposedInsured}
                        options={yesNoOptions}
                        onChange={e => handleValueChange('isProposedInsured', e)}
                        errors={errors.isProposedInsured}
                        labelCenter={true}
                    />
                </Form.Group>
            }

            {
                formState.policyOwnership === policyOwnerships.JOINT && formState.jointOwner !== '' && formState.isProposedInsured === "true" && jointOwner.length >= 1 &&
                <Form.Group>
                    <SelectInput
                        name="insured"
                        id="insured"
                        value={formState.insured}
                        onChange={(e) => handleValueChange('insured', e.target.value)}
                        label="Who is Insured?"
                        selectOptions={getInsuredList()}
                        errors={errors.insured}
                        inputRef={register}
                    />
                </Form.Group>
            }
        </React.Fragment>
    )
}



// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/RetrieveAccount/SubComponents/PolicyAndInsuredFields.js